module.exports = function() {
  return new Worker(__webpack_public_path__ + "ad2d1a2fc8e00c0db973.worker.js");
};